import { render, staticRenderFns } from "./CallToActions.vue?vue&type=template&id=efaa5aa0&scoped=true&"
import script from "./CallToActions.vue?vue&type=script&lang=js&"
export * from "./CallToActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efaa5aa0",
  null
  
)

export default component.exports